class WebSocketService {
    constructor({ trackingNumber, url } = {}) {
        this.trackingNumber = trackingNumber;

        this.baseUrl =
            url ||
            (import.meta.env.PROD
                ? "wss://api.idlogichain.com/ws/iot"
                : "ws://localhost:7195/ws/iot");

        this.connection = null;
        this.reconnectDelay = 5000;
        this.maxReconnectAttempts = 5;
        this.reconnectAttempts = 0;
        this.shouldReconnect = true;
        this.heartbeatInterval = null;

        this.onMessage = null;
        this.onStatusChange = null;
    }

    _setStatus(status) {
        console.log("[WS STATUS]", status);
        this.onStatusChange?.(status);
    }

    _getToken() {
        return (
            localStorage.getItem("authToken") ||
            localStorage.getItem("token") ||
            localStorage.getItem("jwt")
        );
    }

    _buildUrl() {
        const token = this._getToken();

        if (!token) {
            console.error("❌ No JWT token found");
            return null;
        }

        if (!this.trackingNumber) {
            console.error("❌ No trackingNumber provided");
            return null;
        }

        return `${this.baseUrl}?tracking=${encodeURIComponent(
            this.trackingNumber
        )}&access_token=${encodeURIComponent(token)}`;
    }

    connect() {
        const url = this._buildUrl();

        if (!url) {
            this._setStatus("invalid-config");
            return;
        }

        if (
            this.connection &&
            (this.connection.readyState === WebSocket.OPEN ||
                this.connection.readyState === WebSocket.CONNECTING)
        ) {
            return;
        }

        console.log("🔌 Connecting to:", url);
        this._setStatus("connecting");

        this.connection = new WebSocket(url);

        this.connection.onopen = () => {
            console.log("✅ Connected");
            this.reconnectAttempts = 0;
            this._setStatus("connected");
            this._startHeartbeat();
        };

        this.connection.onmessage = (event) => {
            if (this.onMessage) {
                this.onMessage(event.data);
            }
        };

        this.connection.onerror = (err) => {
            console.error("❌ WS Error:", err);
            this._setStatus("error");
        };

        this.connection.onclose = () => {
            this._setStatus("disconnected");
            this._stopHeartbeat();
            this.connection = null;

            if (
                this.shouldReconnect &&
                this.reconnectAttempts < this.maxReconnectAttempts
            ) {
                this.reconnectAttempts++;

                setTimeout(() => this.connect(), this.reconnectDelay);
            } else {
                this._setStatus("failed");
            }
        };
    }

    _startHeartbeat() {
        this._stopHeartbeat();

        this.heartbeatInterval = setInterval(() => {
            if (this.connection?.readyState === WebSocket.OPEN) {
                this.connection.send(JSON.stringify({ type: "ping" }));
            }
        }, 15000);
    }

    _stopHeartbeat() {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = null;
        }
    }

    close() {
        this.shouldReconnect = false;
        this._stopHeartbeat();
        this.connection?.close();
        this.connection = null;
    }
}

export default WebSocketService;